import { get } from 'lodash';
import { actionHandlerWithFeatureFlag } from 'utils';
import { FEATURE_FLAGS } from 'utils/constants';
import DatadogHandler from 'utils/datadog';
import { msFetchAllBusinessEntities } from 'services/SchoolConfigService';
import {
  FETCH_ALL_BUSINESS_ENTITIES,
  FETCH_ALL_BUSINESS_ENTITIES_ERROR,
  FETCH_ALL_BUSINESS_ENTITIES_SUCCESS,
} from './actionTypes';
import { SkApolloRequest } from '../../utils/apolloUtils';
import { FIND_ALL_BUSINESS_ENTITIES_GQL } from '../models/marketingConsentModel';

const fileName = 'redux/actions/MarketingConsent.js';

export const monoFetchAllBusinessEntities = async (dispatch, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: FIND_ALL_BUSINESS_ENTITIES_GQL,
        variables: { ...reqData },
      },
      type: 'query',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        fileName,
        functionName: 'monoFetchAllBusinessEntities',
      },
      'error'
    );
    dispatch({
      type: FETCH_ALL_BUSINESS_ENTITIES_ERROR,
      value: { error: get(ex, 'message') },
    });
    return ex;
  }
};

export const fetchAllBusinessEntities = reqData => async dispatch => {
  dispatch({ type: FETCH_ALL_BUSINESS_ENTITIES });
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msFetchAllBusinessEntities,
        monoHandler: monoFetchAllBusinessEntities,
        extraData: reqData,
      }
    );

    const success = get(data, 'success', false);
    const allBusinessEntity = get(data, 'data.findAllBusinessEntity', {});
    if (success) {
      dispatch({
        type: FETCH_ALL_BUSINESS_ENTITIES_SUCCESS,
        value: allBusinessEntity,
      });
    } else {
      dispatch({
        type: FETCH_ALL_BUSINESS_ENTITIES_ERROR,
        value: get(data, 'error'),
      });
    }
    return allBusinessEntity;
  } catch (ex) {
    return ex;
  }
};
export default fetchAllBusinessEntities;
